import { Logo } from "./Logo";

interface Props {
  id: string | undefined;
}

// todo - add support to get name for title
export const OrgLogo = ({ id }: Props) => {
  return <Logo key={id} id={id} type="Org" />;
};
